import Model, { attr, belongsTo } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class RateModel extends Model {
  @attr('date') date!: Date;
  @attr('number') price!: number;
  @attr('number') directPrice!: number;
  @attr('number') airbnbOfficialPrice!: number;
  @attr('number') bookingDotComPrice!: number;
  @attr('number') googlePrice!: number;
  @attr('number') homeAwayPrice!: number;
  @attr('number') guestPaysPrice!: number;
  @attr('number') mlos!: number;
  @attr('boolean') closedForArrival!: boolean;
  @attr('boolean') closedForDeparture!: boolean;
  @attr('boolean') spotRate!: boolean;
  @attr('boolean') spotMlos!: boolean;
  @attr('boolean') spotClosedForArrival!: boolean;
  @attr('boolean') spotClosedForDeparture!: boolean;

  @belongsTo('property', {
    inverse: 'rates',
    async: false,
  })
  property!: ModelRegistry['property'];

  @belongsTo('calendar', {
    inverse: 'rates',
    async: false,
  })
  calendar!: ModelRegistry['calendar'];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    rate: RateModel;
  }
}
